export default "/images/framework/HistoryLink.7c92278c.svg?7c92278c";